import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { useQuoteRequestLine } from "#modules/quoteRequestLines/view/useQuoteRequestLine";
import { ClusterCardData } from "#modules/similarPart/view/clustering/ClusterCardData";
import { ClusterCardHeader } from "#modules/similarPart/view/clustering/ClusterCardHeader";
import { TargetDto } from "#modules/similarPart/view/SearchResult";
import { Paper } from "#shared/view/components/Paper";
import { Stack } from "#shared/view/components/Stack";
import { ThumbnailOverlay } from "#shared/view/components/Thumbnails/ThumbnailOverlay";
import { ButtonLink } from "#shared/view/designSystem/ButtonLink";

export type ProcessStepFromQuoteRequestLine = ClientInferResponseBody<
  typeof contract.quoteRequestLines.findOne
>["processSteps"][number];

export const CompareCard = ({
  targetPart,
  sourceQuoteRequestLine,
  removeFromCluster,
}: {
  targetPart: TargetDto;
  sourceQuoteRequestLine: QuoteRequestLineDto | undefined | null;
  removeFromCluster: (id: string | undefined) => void;
}) => {
  const { quoteRequestLine } = useQuoteRequestLine({
    id: targetPart.id,
  });

  if (!quoteRequestLine || !sourceQuoteRequestLine) {
    return null;
  }

  const processSteps: ProcessStepFromQuoteRequestLine[] = quoteRequestLine.processSteps;

  return (
    <Paper p="xxs" withBorder radius={10}>
      <Stack gap={"xxs"} justify="space-between">
        <ButtonLink onClick={() => removeFromCluster(quoteRequestLine.id)}>
          Supprimer du cluster
        </ButtonLink>

        <ClusterCardHeader quoteRequestLine={quoteRequestLine} />

        <ThumbnailOverlay
          size={{ width: "100%", height: "100%" }}
          part={quoteRequestLine.part}
          quoteRequestLineId={quoteRequestLine.id}
        />

        <ClusterCardData quantity={quoteRequestLine.quantity}>
          <ClusterCardData.Chips quoteRequestLine={quoteRequestLine} />
          <ClusterCardData.Features quoteRequestLine={quoteRequestLine} />
          <ClusterCardData.Quantity quantity={sourceQuoteRequestLine.quantity} />
          <ClusterCardData.Costs
            processSteps={processSteps}
            quantity={sourceQuoteRequestLine.quantity}
            quoteRequestLine={quoteRequestLine}
            sourceQuoteRequestLine={sourceQuoteRequestLine}
          />
        </ClusterCardData>
      </Stack>
    </Paper>
  );
};
